import NextLink from "next/link";
import { useState } from "react";
import { useRouter } from "next/navigation";
import { WeekCard } from "@aph/ui-lib-humanx";
import IconLeft from "$/icons/icon-left.svg";
import IconRight from "$/icons/icon-right.svg";
import Slider, { Slide } from "@/components/Slider";
import sliderStyles from "@/components/Slider/Slider.module.scss";
import routes from "@/helpers/router";
import SectionHeader from "@/components/SectionHeader";
import styles from "./ClustersByPillar.module.scss";

const ClustersByPillar = ({ Pillars, ClustersArray, deviceType, data }) => {
  const [activePillar, setActivePillar] = useState(Pillars?.[0]?.slug);
  const [activePillarName, setActivePillarName] = useState(Pillars?.[0]?.name);

  const router = useRouter();

  const handleClusterClick = (slug: string) => () => {
    router.push(routes.cluster(slug));
  };

  return (
    <>
      <div className={`container ${styles.clustersByPillarWrapper} spacingBetweenSections`}>
        <SectionHeader
          userAgent={deviceType}
          title={data?.Title}
          subTitle={data?.Description}
          className={styles.sectionHeader}
        />
        <div className={styles.tabsWrapper}>
          {Pillars?.map(({ name, slug }: any) => {
            const isActive = slug === activePillar;

            return (
              <div key={slug}>
                <button
                  type={"button"}
                  onClick={() => {
                    setActivePillar(slug);
                    setActivePillarName(name);
                  }}
                  key={slug}
                  className={`${styles.tab} ${isActive ? styles.active : ""}`}
                >
                  {name}
                </button>
              </div>
            );
          })}
        </div>

        <div className={styles.panel}>
          <Slider
            autoplay={false}
            showArrows={deviceType?.isDesktop}
            showDots={false}
            dotsWrapperClass={sliderStyles.dotsWrapperClass}
            dotClass={sliderStyles.dotClass}
            dotClassActive={sliderStyles.dotClassActive}
            slidesToShow={deviceType?.isDesktop ? 6 : 1.5}
            columnGap={15}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
            resetOnChildrenUpdate
          >
            {ClustersArray?.[activePillar]?.map((cluster, index) => {
              return (
                <Slide key={`ra-${index}`} index={index} className={styles.sliderRoot}>
                  <WeekCard
                    redirectUrl={routes.cluster(cluster?.Slug)}
                    title={cluster?.Name}
                    onClick={handleClusterClick(cluster?.Slug)}
                    isRightIcon
                  />
                </Slide>
              );
            })}
          </Slider>
          {deviceType?.isMobile && (
            <NextLink href={routes.pillar(`${activePillar}`)} className={styles.link} prefetch={false}>
              <span className={styles.btn}>{`Explore ${activePillarName}`}</span>
            </NextLink>
          )}
        </div>
      </div>
    </>
  );
};

export default ClustersByPillar;
